import { useEffect, useRef, useState } from "react";

import api from "@helpers/api";
import { adaptMyEnrollmentListItem } from "@pages/Mentoring/helpers/apiAdapters";

// Only running mentorings drive the sidebar shortcut (§6.0): active mentoring or
// a still-running revenue split.
const SHORTCUT_STATUSES = new Set(["active", "split_only", "awaiting_community"]);

/**
 * Sidebar shortcut data (§6.0). Returns the creator's active mentorings so the
 * admin section can render: nothing (0), a direct link (1) or a stacked-banner
 * "Mentorias" button (2+). A request stale-guard drops late responses; the
 * shortcut renders nothing while loading.
 */
export default function useCreatorMentorings() {
  const [mentorings, setMentorings] = useState([]);
  const [loading, setLoading] = useState(true);

  const requestRef = useRef(0);

  useEffect(() => {
    const requestId = ++requestRef.current;

    (async () => {
      const res = await api.get("mentoring/my-enrollments", { per_page: 50 });
      if (requestId !== requestRef.current) return;

      const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
      setMentorings(
        rows
          .filter((e) => SHORTCUT_STATUSES.has(e.status))
          .map(adaptMyEnrollmentListItem),
      );
      setLoading(false);
    })();
  }, []);

  return { mentorings, loading };
}
